import { features } from '@/mocks/tmtData';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const fadeIn = (visible: boolean, delay: string) => ({
  opacity: visible ? 1 : 0,
  transform: visible ? 'translateY(0)' : 'translateY(24px)',
  transition: 'all 700ms ease-out',
  transitionDelay: delay,
});

export default function FeaturesSection() {
  const [headerRef, headerVisible] = useScrollReveal<HTMLDivElement>({ threshold: 0.15 });
  const [gridRef, gridVisible] = useScrollReveal<HTMLDivElement>({ threshold: 0.08 });

  return (
    <section className="bg-background-100/95 py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div ref={headerRef} className="mb-12 md:mb-16">
          <span
            className="inline-block font-label text-xs tracking-[0.2em] uppercase text-primary-400 mb-3"
            style={fadeIn(headerVisible, '0ms')}
          >
            / Why Choose TMT
          </span>
          <h2
            className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-primary-400 leading-tight max-w-2xl"
            style={fadeIn(headerVisible, '100ms')}
          >
            Built for Trust.
            <br />
            Designed for Speed.
          </h2>
        </div>

        {/* Features Grid */}
        <div ref={gridRef}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {features.map((feature, i) => (
              <div
                key={feature.id}
                className="group p-6 md:p-8 bg-background-50/90 rounded-xl border border-primary-800/20 hover:border-primary-600/40 transition-all duration-500"
                style={fadeIn(gridVisible, `${i * 100}ms`)}
              >
                <div className="w-12 h-12 flex items-center justify-center border border-primary-600/40 rounded-lg mb-5 group-hover:border-primary-400 transition-colors">
                  <i className={`${feature.icon} text-primary-400 text-xl`} />
                </div>
                <h3 className="font-heading text-xl text-foreground-100 mb-3 group-hover:text-primary-400 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-foreground-400 text-sm leading-relaxed font-body">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}